module.exports = __webpack_public_path__ + "static/media/giraffe.66095ea2.gif";